
export default {
    format(datas = null, suffix = '', level = 0){
        if(level === 0){
            let vie = JSON.stringify({
                "header":true,
                "title":"Vie",
                "hiddenOnCollapse":false,
                "class":"part-first header"
            }) + "," + this.format(datas.vie.criteriaCategorieChildren,suffix+"vie", level + 1);

            let dommages = JSON.stringify({
                "header":true,
                "title":"Dommages",
                "hiddenOnCollapse":false,
                "class":"part-second header"
            }) + "," + this.format(datas.dommages.criteriaCategorieChildren,suffix+"dommages", level + 1);

            let qualite = JSON.stringify({
                "header":true,
                "title":"Qualité",
                "hiddenOnCollapse":false,
                "class":"part-three header"
            }) + "," + this.format(datas.qualite.criteriaCategorieChildren,suffix+"dommages", level + 1);

            let result = "[" + vie + "," + dommages + "," + qualite + "]";

            let resultJson = JSON.parse(result);

            return resultJson;
        }
        else if(level === 1){
            let childs = [];
            for(let i = 0; i < datas.length; i ++){
                let element = {
                    href : "",
                    title : datas[i].name,
                    icon : datas[i].picto,
                    class : "part-first",
                };

                if(datas[i].criteriaCategorieChildren && datas[i].criteriaCategorieChildren.length > 0){
                    element.child = this.format(datas[i].criteriaCategorieChildren,suffix+"/"+datas[i].id, level + 1);
                } else {
                    element.href = suffix+"/"+datas[i].id;
                }

                childs.push(element);
            }
            let result = "";
            for (let i = 0; i < childs.length; i++){
                if(i === 0){
                    result = result + JSON.stringify(childs[i])
                } else {
                    result = result + "," + JSON.stringify(childs[i])
                }
            }
            return result;
        }
        else if(level === 2){
            let childs = [];
            for(let i = 0; i < datas.length; i ++){
                let element = {
                    title : datas[i].name,
                    href : suffix+"/"+datas[i].id,
                };

                if(datas[i].criteriaCategorieChildren && datas[i].criteriaCategorieChildren.length > 0){
                    element.child = this.format(datas[i].criteriaCategorieChildren,suffix+"/"+datas[i].id, level + 1);
                }

                childs.push(element);
            }

            return childs;
        }
    }
}


/*export default {
    format(datas = null, suffix = '', level = 0){
        if(level == 0){
            return {

                vie : {
                    name : datas.vie.name,
                    href : suffix+"vie",
                    child : this.format(datas.vie.criteriaCategorieChildren,suffix+"vie", level + 1)
                },
                dommages : {
                    name : datas.dommages.name,
                    href : suffix+"dommages",
                    child : this.format(datas.dommages.criteriaCategorieChildren,suffix+"dommages", level + 1)
                },
                qualite : {
                    name : datas.qualite.name,
                    href : suffix+"qualite",
                    child : this.format(datas.qualite.criteriaCategorieChildren,suffix+"qualite", level + 1)
                }
            }
        }
        else {
            let childs = [];
            for(let i = 0; i < datas.length; i ++){
                let element = {
                    id : datas[i].id,
                    name : datas[i].name,
                    href : suffix+"/"+datas[i].id,
                    picto : datas[i].picto
                };

                if(datas[i].criteriaCategorieChildren && datas[i].criteriaCategorieChildren.length > 0){
                    element.child = this.format(datas[i].criteriaCategorieChildren,suffix+"/"+datas[i].id, level + 1);
                }

                childs.push(element);
            }

            return childs;
        }
    }
}*/
